import { formatUTCTimestampToLocal } from '../../../../../utils/set-date-range-utils';
import React from 'react'
import ExpenseBarChart from './expense-chart';
import { getNameByStatus } from '../../../../../utils/getnamebystatus-utils';
import { statusColors } from '../../../../../utils/status-color-utils';
import { camelCaseToWords } from '../../../../../utils/structure-words-utils';

const DataBoxes = ({ vehicleDetails, overview, attributes }) => {
    // console.log("overview : ", overview)
    // console.log("details : ", vehicleDetails)

    const getLightBg = (color) => {
        if (!color) return '#F4F4F4';
        return `${color}33`; // adds ~20% opacity
    };

    const allowedFields = ['vehicleId', 'accountId', 'vin', 'licensePlate', 'make', 'model', 'year', 'vehicleType', 'bodyClass', 'fuelType', 'note', 'creator', 'createdOn', 'status'];
    const specialFields = ["fuelType", "vehicleType", "status"];
    return (
        <div className='grid md:grid-cols-2 grid-cols-1 gap-4 my-6'>
            {/* vehicle feilds details */}
            <div className=' border rounded-lg p-3 min-h-28 shadow-md'>
                <h3 className="font-semibold text-gray-800 text-lg mb-3">
                    All Fields Details
                </h3>
                {Object.entries(vehicleDetails)
                    ?.filter(([key]) => allowedFields.includes(key))
                    ?.map(([key, value], index, array) => (
                        <div
                            key={key}
                            className={`flex justify-between gap-16 ${index === array.length - 1 ? ' py-3' : 'border-b py-3'}`}
                        >
                            <h1 className='w-48 font-medium'>{camelCaseToWords(key)}</h1>
                            <p className='flex-1 flex justify-start text-start'>
                                {value !== null && value !== undefined ? (
                                    key === 'createdOn'
                                        ? formatUTCTimestampToLocal(value, 'yyyy-MM-dd hh:mm a')
                                        : key === 'creator' && typeof value === 'object'
                                            ? value.name
                                            : typeof value === 'object'
                                                ? JSON.stringify(value)
                                                : specialFields.includes(key)
                                                    ? camelCaseToWords(value)
                                                    : value
                                ) : ''}
                            </p>
                        </div>
                    ))}

            </div>

            <div className='flex-1'>

                <div className='grid md:grid-cols-2 grid-cols-1 gap-4 w-full mb-4'>
                    <div className='border rounded-lg p-3 min-h-28 shadow-md '>
                        <h3 className="font-semibold text-gray-800 text-lg mb-3">
                            Cost of Ownership({attributes?.currency})
                        </h3>
                        <h1 className='text-green-700 lg:text-4xl text-3xl text-center my-3 font-extrabold'>{overview?.expensesSumLifetimeVehicle}</h1>
                    </div>

                    {/* Incident Count By Status */}
                    {overview?.incidentCountByStatus && (
                        <div className="border rounded-lg w-full p-3 shadow-md">
                            <h3 className="font-semibold text-gray-800 text-lg">
                                {getNameByStatus('incidentCountByStatus')}
                            </h3>
                            <div className="mt-3 space-y-2">
                                {overview?.incidentCountByStatus.length > 0 ? (
                                    overview?.incidentCountByStatus.map((item, i) => {
                                        const color = statusColors[item.slug] || statusColors.default;
                                        return (
                                            <div key={item.slug} className={`flex items-center justify-between ${i !== overview?.incidentCountByStatus.length - 1 ? 'border-b' : ''} pb-2`}>
                                                <div className="flex items-center space-x-2">
                                                    <span className="w-3 h-3 rounded-full" style={{ backgroundColor: color }}></span>
                                                    <span className="text-gray-700 text-sm">{item.label}</span>
                                                </div>
                                                <span
                                                    className="px-4 py-0.5 rounded-full text-sm font-medium"
                                                    style={{
                                                        backgroundColor: getLightBg(color),
                                                        color: color
                                                    }}
                                                >
                                                    {item.total}
                                                </span>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p className="text-gray-500 text-sm">No data available</p>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* expense cahrt */}
                <div className='border rounded-lg p-3 min-h-28 shadow-md mb-4'>
                    <h3 className="font-semibold text-gray-800 text-lg mb-3">
                        Expenses
                    </h3>
                    <ExpenseBarChart
                        fuelData={overview?.expensesSumMonthly?.expensesSumMonthlyFuel}
                        serviceData={overview?.expensesSumMonthly?.expensesSumMonthlyService}
                        otherData={overview?.expensesSumMonthly?.expensesSumMonthlyOther}
                        unit={attributes?.currency}
                    />
                </div>

                {/* reminders */}
                <div className='grid md:grid-cols-2 grid-cols-1 gap-4 mb-4'>
                    {/* Service Reminders */}
                    {overview?.reminderCountByStatus && overview?.reminderCountByStatus.service && (
                        <div key="serviceReminders" className='border rounded-lg p-3 min-h-28 shadow-md'>
                            <h3 className="font-semibold text-gray-800 text-lg">
                                Service Reminders
                            </h3>
                            <div className=" mt-3 flex items-center gap-3 justify-around">
                                <div className='flex flex-col items-center gap-3'>
                                    <p className='text-green-700 text-4xl font-extrabold'>{overview?.reminderCountByStatus.service.overdue}</p>
                                    <h1 className='text-center text-sm'>Service Overdue</h1>
                                </div>
                                <div className='flex flex-col items-center gap-3'>
                                    <p className='text-green-700 text-4xl font-extrabold'>{overview?.reminderCountByStatus.service.dueSoon}</p>
                                    <h1 className='text-center text-sm'>Service DueSoon</h1>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Renewal Reminders */}
                    {overview?.reminderCountByStatus && overview?.reminderCountByStatus.renewal && (
                        <div key="renewalReminders" className='border rounded-lg p-3 min-h-28 shadow-md'>
                            <h3 className="font-semibold text-gray-800 text-lg">
                                Renewal Reminders
                            </h3>
                            <div className=" mt-3 flex items-center gap-3 justify-around">
                                <div className='flex flex-col items-center gap-3'>
                                    <p className='text-purple-700 text-4xl font-extrabold'>{overview?.reminderCountByStatus.renewal.overdue}</p>
                                    <h1 className='text-center text-sm'>Renewal Overdue</h1>
                                </div>
                                <div className='flex flex-col items-center gap-3'>
                                    <p className='text-purple-700 text-4xl font-extrabold'>{overview?.reminderCountByStatus.renewal.dueSoon}</p>
                                    <h1 className='text-center text-sm'>Renewal DueSoon</h1>
                                </div>
                            </div>
                        </div>
                    )}
                </div>


            </div>


        </div>
    )
}

export default DataBoxes